<template>
		<a-card>
			<div class="search">
				<a-form-model layout="inline" :model="searchForm">
					<a-form-model-item label="学校名称">
	                    <a-input :maxLength="30" v-model="searchForm.schoolName" placeholder="请输入"/>
	                </a-form-model-item>
					<a-form-model-item label="地区">
	                    <a-cascader
	                        @keyup.enter="getPageList(1)"
	                        v-model="address"
	                        :options="addressOptions"
	                        :load-data="addressLoadData"
	                        @change="addressChange"
	                        placeholder="请选择机构地址"
	                        change-on-select
	                        allowClear/>
	                </a-form-model-item>
					<a-form-model-item label="上级机构">
	                    <a-select class="serach-item" show-search :filter-option="filterOption" allowClear
	                              v-model="searchForm.superiorId" placeholder="请选择上级机构">
	                        <a-select-option :value="item.id" v-for="item in treeData" :key="item.id">
	                            {{item.name}}
	                        </a-select-option>
	                    </a-select>
	                </a-form-model-item>
					<a-form-model-item label="状态">
	                    <a-select class="serach-item" v-model="searchForm.enabled" allowClear placeholder="请选择">
	                        <a-select-option value="true">启用</a-select-option>
	                        <a-select-option value="false">禁用</a-select-option>
	                    </a-select>
	                </a-form-model-item>
					<a-form-model-item style="margin-right: 35px;">
	                    <a-button @click="getPageList(1)" type="primary" html-type="button">
	                        查询
	                    </a-button>
						<a-button icon="history"
	                              @click="resetComputed()" style="margin-left: 10px;" type="primary">重新算分
	                    </a-button>
	                </a-form-model-item>
				</a-form-model>
			</div>
			<div style="overflow: auto;margin-top: 15px;">
				<a-table
					style="min-width: 800px;"
					:columns="columns"
					rowKey="id"
					:pagination="tableRelevant.tablePagination"
					:loading="tableRelevant.tableLoading"
					:locale="tableRelevant.locale"
					:dataSource="tableRelevant.tableDataSource">
					<span slot="orgSuperiorName" slot-scope="text">
	                    {{ text.orgSuperiorName}}
	                </span>
					<span slot="enabled" slot-scope="text" class="enabled">
						<div :class=" text.enabled ? 'yuan active' : 'yuan'"></div>
	                    {{ text.enabled ? '启用' : '禁用' }}
	                </span>
				</a-table>
			</div>
			<!-- 重新算分 -->
	        <a-modal v-model="isResetComputed" title="重新算分" width='60%' :footer="false">
	            <div class="table">
	                <a-button @click="calculatePoints" :loading="rcLoading" type="primary" icon="calculator"
	                          style="margin-bottom: 15px;">重算分数
	                </a-button>
	                <a-table :columns="rcColumns"
	                         rowKey="contentId"
	                         :scroll="{y: 350}"
	                         :row-selection="rcTableSelection"
	                         :loading="rcTable.tableLoading"
	                         :dataSource="rcTable.tableDataSource"
	                         :pagination="rcTable.tablePagination">
	                    <div slot="contentType" slot-scope="text">
	                        <span v-if="text === 1" style="color:#2F4056;">测评游戏</span>
	                        <span v-if="text === 2" style="color:#FF5722;">训练游戏</span>
	                        <span v-if="text === 3" style="color:#009688;">题目壳</span>
	                        <span v-if="text === 4" style="color:#4982ff;">课程视频</span>
	                    </div>
	                </a-table>
	            </div>
	        </a-modal>
		</a-card>
	</template>

<script>
import {tableRelevant} from "@/pages/projectImpl/js/utils";
import $Bus from "@/pages/projectImpl/js/eventBus";

const columns = [
    { title: '学校名称', key: "1", dataIndex: 'schoolName'},
    { title: '地区', key: "2", dataIndex:'area'},
    { title: '上级机构', key: "3", dataIndex: 'orgSuperiorName'},
    { title: '状态', key: "4", scopedSlots: {customRender: 'enabled'}},
];

const rcColumns = [
    {
        title: "内容名称",
        dataIndex: "contentName",
        align: 'center'
    },
    {
        title: "内容类型",
        align: 'center',
        dataIndex: "contentType",
        scopedSlots: {customRender: "contentType"}
    },
];
export default {
		data(){
			return {
				searchForm:{
					schoolName:'',
					districtId:undefined,
					superiorId:undefined,
					enabled:undefined,

				},
            address: undefined,
            //地址
            addressOptions: [],
            // 上级机构
            treeData: [],

				columns,
				tableRelevant: tableRelevant.call(this),

				rcColumns,
            rcLoading: false,
            rcSelectList: [],//重新算分选中
            isResetComputed: false,//重新算分弹窗
            rcTable: tableRelevant.call(this, this.getRcData),//重新算分弹窗数据
			}
		},
		computed:{
			rcTableSelection() {
	            return {
	                selectedRowKeys: this.rcSelectList,
	                onChange: (selectedRowKeys, selectedRows) => {
	                    this.rcSelectList = selectedRowKeys;
	                }
	            };
	        },
		},
		mounted(){
	        const arr = ["首页", "项目实施", {name: "机构管理", path: this.$store.getters["organization/getOrganizationFullPath"]() || "/projectImpl/pMechanism"}, {
	            name: "机构详情",
	            path: "/projectImpl/organizationDetails"
	        }, "区域项目设置"];
	        $Bus.$emit("pageHeaderBreadcrumb", arr);
			this.getPageList()
	        this.getAddressList();
	        this.getTreeData()
		},
		methods:{
	        //获取上级机构
	        getTreeData() {
	            let params = {
	                type: 0
	            }
	            this.$http.Mechanism.getSuperiorOrg(params).then(res => {
	                const {data} = res;
	                this.treeData = data
	            });
	        },
	        filterOption(input, option) {
	            return (
	                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
	            );
	        },
	        /**
	         * 获取地址
	         * @param id 查询的省市区
	         */
	        getAddressList(id) {
	            return new Promise((resolve, reject) => {
	                this.$http.Mechanism.address({parentId: id || 0}).then(res => {
	                    const {data} = res.data;
	                    if (id) {
	                        resolve(data.map(v => {
	                            return {
	                                id: v.id,
	                                value: v.id + "," + v.name,
	                                label: v.name,
	                                isLeaf: v.level === 4,
	                                loading: false,
	                            }
	                        }));
	                    } else {
	                        this.addressOptions = data.map(v => {
	                            return {
	                                id: v.id,
	                                value: v.id + "," + v.name,
	                                label: v.name,
	                                isLeaf: false,
	                                loading: false,
	                            }
	                        })
	                    }
	                })
	            });
	        },
	        addressLoadData(selectedOptions) {
	            const targetOption = selectedOptions[selectedOptions.length - 1];
	            targetOption.loading = true;
	            return this.getAddressList(targetOption.value.split(",")[0]).then(data => {
	                targetOption.loading = false;
	                targetOption.children = data;
	                this.addressOptions = [...this.addressOptions];
	                return data;
	            })
	        },
	        addressChange(value) {
	            if(value.length == 1){
	                this.searchForm.districtId = value[0] && value[0].split(",")[0];
	            }else if(value.length == 2){
	                this.searchForm.districtId = value[1] && value[1].split(",")[0];
	            }else if(value.length == 3){
	                this.searchForm.districtId = value[2] && value[2].split(",")[0];
	            }else{
	                this.searchForm.districtId = undefined
	            }
	            console.log(this.searchForm.districtId);
	        },
			getPageList(pageIndex){
				const params = {
					customerCourseId:this.$route.query.id,
					pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
					pageSize: this.tableRelevant.tablePagination.pageSize,
					...this.searchForm
				};
				this.tableRelevant.tableLoading = true;
				this.$http.Course.SubordinateCustomerCoursePageList(params)
				.then(res => {
					const {data} = res;
					this.tableRelevant.tableDataSource = data.items;
					this.tableRelevant.tablePagination.total = data.totalCount;
					this.tableRelevant.tablePagination.current = data.pageIndex
				}).finally(() => {
	        this.tableRelevant.tableLoading = false;
	      })
			},
			// 重新算分弹窗
	        resetComputed() {
	            this.isResetComputed = true
	            this.getRcData()
	        },
			getRcData(){
				let params = {
	                superiorCustomerCourseId: this.$route.query.id,
	            };
	            this.rcTable.tableLoading = true;
	            this.$http.Course.GetSuperiorCustomerCourseEvaluationContents(params).then(res => {
	                const {data} = res;
	                this.rcTable.tableDataSource = data;
	                this.rcTable.tablePagination.total = data.length;
	            }).finally(() => {
	                this.rcTable.tableLoading = false;
	            })
			},
			calculatePoints(){
	            this.$message.destroy();
				if(!this.rcSelectList.length){
					this.$message.warning('请选择');
	                return
				}
				let formData = new FormData();
	            formData.append('superiorCustomerCourseId', this.$route.query.id);
	            this.rcSelectList.forEach(v => {
	                formData.append(`contentIds`, v)
	            });
				// let params = {
				// 	customerCourseId :this.$route.query.id,
				// 	contentIds:this.rcSelectList
				// }
	            this.rcLoading = true;
	            this.$http.Course.UpdateCourseContentScore(formData).then(res => {
	                this.$message.destroy();
	                this.rcSelectList = [];
	                this.isResetComputed = false;
	                this.$message.success(res.message);
	            }).finally(() => {
	              this.rcLoading = false;
	            })
			},
		}
	}
	</script>

<style>

</style>